import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import { API_BASE_URL } from '../config/api';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";

const ToolsStory = () => {
	const [username, setUsername] = useState("");
	const [generating, setGenerating] = useState(false);
	const [stories, setStories] = useState([]);
	const [foundStory, setFoundStory] = useState(true);
	const [functionError, setFunctionError] = useState("");
	const [functionSuccess, setFunctionSuccess] = useState("");

	const viewStory = async () => {

		try {
			const formData = {};
			formData.username =  username;
			

			setGenerating(true);
			setFoundStory(true)

			const response = await axiosClient.post("https://api.viralgpt.com/tools/story", formData, {
			headers: {
				"Content-Type": "application/json",
			},
			});
			setGenerating(false);
			setStories(response.data.reply);
			if (response.data.reply.length == 0){
				setFoundStory(false)
			} else {
				setFoundStory(true)
			}
			console.log("Server response:", response.data);
			setFunctionSuccess("Story viewed successfully.");
		} catch (e) {
			setGenerating(false);
			setFunctionError("An error occurred while viewing the story: " + e.response.data.error);
		}
	};


  return (
	<>
		<div className="bg-white border p-6">
              <h5>Story Viewer</h5>
              <p className="text-muted">Anonymously view someones live story.</p>

				<Alert 
					variant="danger" 
					message={functionError} 
					show={!!functionError} 
					onClose={() => setFunctionError("")} 
				/>
				
				<Alert 
					variant="success" 
					message={functionSuccess} 
					show={!!functionSuccess} 
					onClose={() => setFunctionSuccess("")} 
				/>

              {/* Link Input */}
              <Form.Group controlId="commentsLink" className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter a username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              {/* Start Delivery Button */}
              <div className="d-flex align-items-center">
                <Button className={generating ? "disabled bg-instagram" : "bg-instagram"} onClick={() => viewStory()}>
                  View Story
                </Button>
                <div style={{ fontSize: "1.5rem" }} className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!generating ? "d-none" : ""}`} />
              </div>
              {foundStory === false ? <p>No posts were found</p> : <p></p>}
			
           
			
			<div className="row mt-3">
				{stories.map((idea, index) => (
					<div
					key={index}
					className="col-12 col-md-6 col-lg-4"
					style={{
						display: "col-auto",
						marginBottom: "1rem",  // Optional spacing between rows
					}}
					>
					
						<video className="h-auto" controls >
						<source src={idea + "#t=0.1"} type="video/mp4" />
						Your browser does not support the video tag.
						</video>
					</div>

					
					
					
				))}
				 </div>
			</div>
	</>
  );
};

export default ToolsStory;
